import React from 'react';

import type { UserDto } from '../../api/types';
import { getInitialsFromName } from '../../domain/users/display';
import type { AuthUser } from '../../store/slices/authSlice';
import { RoleBadge } from '../members/RoleBadge';

import './InvitedUsersList.css';

type InvitedUsersListProps = {
  users: UserDto[];
  onRemove: (telegramId: string) => void;
  reservedSlotsCount?: number;
  currentUser?: AuthUser | null;
  onRemoveReservedSlot?: () => void;
};

export function InvitedUsersList({
  users,
  onRemove,
  reservedSlotsCount,
  currentUser,
  onRemoveReservedSlot,
}: InvitedUsersListProps) {
  const hasInvited = users.length > 0;
  const hasReserved = (reservedSlotsCount ?? 0) > 0;

  if (!hasInvited && !hasReserved) {
    return null;
  }

  return (
    <div className="invited-users-list">
      {hasInvited && (
        <>
          <div className="invited-users-title">Приглашённые участники ({users.length})</div>
          <div className="invited-users-items">
            {users.map((user) => {
              const isValidUrl =
                user.photoUrl &&
                (user.photoUrl.startsWith('http') || user.photoUrl.startsWith('/'));
              const fullName = `${user.firstName} ${user.lastName}`.trim();
              const initials = getInitialsFromName(fullName);

              return (
                <div key={user.telegramId} className="invited-user-item">
                  <div className="mi-avatar-wrap mi-avatar-wrap--confirmed">
                    <div className="mi-avatar">
                      {isValidUrl ? (
                        <img src={user.photoUrl} alt={fullName} />
                      ) : (
                        <span className="member-avatar-placeholder">{initials}</span>
                      )}
                    </div>
                  </div>
                  <RoleBadge role={user.role} />
                  <div className="mi-content invited-user-content">
                    <span className="member-name">{fullName}</span>
                    <button
                      type="button"
                      className="member-remove-btn"
                      onClick={() => onRemove(user.telegramId)}
                      aria-label="Удалить"
                    >
                      {'\u2715'}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      {hasReserved && currentUser && (
        <div className="invited-users-items">
          {Array.from({ length: reservedSlotsCount! }).map((_, i) => {
            const name = `${currentUser.first_name} ${currentUser.last_name}`.trim();
            const username = currentUser.username;
            return (
              <div key={`reserved-${i}`} className="invited-user-item invited-user-item--reserved">
                <div className="mi-avatar-wrap">
                  <div className="mi-avatar">
                    <span className="member-avatar-placeholder">{'\uD83D\uDD12'}</span>
                  </div>
                </div>
                <RoleBadge role={currentUser.role} />
                <div className="mi-content invited-user-content">
                  <div className="member-info">
                    <span className="member-name">
                      {username ? <a href={`https://t.me/${username}`}>{name}</a> : name}
                    </span>
                    <span className="member-reserved-label">Зарезервировано</span>
                  </div>
                  <button
                    type="button"
                    className="member-remove-btn"
                    onClick={onRemoveReservedSlot}
                    aria-label="Убрать"
                  >
                    {'\u2715'}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
